import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { CardsSize } from '../enums/cards-size.enum';

@Directive({
    selector: '[cardItemSize]'
})
export class CardItemSizeDirective implements OnInit {
    @Input('cardItemSize') public cardSize: CardsSize;
    private sizeClasses: any[] = [{ key: CardsSize.SMALL, value: 'size-small' }, { key: CardsSize.MEDIUM, value: 'size-medium' }, { key: CardsSize.LARGE, value: 'size-large' }, { key: CardsSize.XLARGE, value: 'size-xlarge' }];

    constructor(private renderer: Renderer2, private hostElement: ElementRef) {

    }

    ngOnInit(): void {
        let targetClass: string;
        for (let size of this.sizeClasses) {
            this.renderer.removeClass(this.hostElement.nativeElement, size.value);

            if (size.key == this.cardSize) {
                targetClass = size.value;
            }
        }

        if (targetClass != undefined) {
            this.renderer.addClass(this.hostElement.nativeElement, targetClass);
        }
    }
}


// WEBPACK FOOTER //
// /home/gitlab-runner/builds/VyQQATNu/0/groupe-dev/nm17/node_modules/nm-socle-application/app/components/card-list/directives/card-item-size.directive.ts